/**
 * The word the Close button of a dialog and of a sheet goes by.
 *
 * Both primitives draw that button themselves, an X with its name said to a
 * screen reader alone, and the name used to be written into each of them: the
 * one string of every dialog that went round the translations, so a Czech
 * screen reader user heard "Close" on each (7 Oct 2026).
 *
 * Read from `useLanguage()` inside the primitive and defaulted here, the rule
 * the controls' own copy follows (`strategyHelpCopy`, `compsetTableCopy`). A
 * primitive is mounted by every page, and what a page hands it is whatever
 * that page's test or harness mocked the provider with: often a handful of
 * groups, `common` not among them. A button with no name is worse than one
 * named in English, so a table without the word gets the English one, read
 * off `en` so that a reworded string cannot leave a stale copy of itself
 * behind as the fallback.
 */

import { en } from "../../i18n/en";

export function closeLabel(t: { common?: { close?: string } }): string {
    return t.common?.close ?? en.common.close;
}
